module.exports = __webpack_public_path__ + "static/media/search_grey.c98cc467.svg";